import { render, staticRenderFns } from "./ScreenRecorderControls.vue?vue&type=template&id=e35ab188&scoped=true&"
import script from "./ScreenRecorderControls.vue?vue&type=script&lang=js&"
export * from "./ScreenRecorderControls.vue?vue&type=script&lang=js&"
import style0 from "./ScreenRecorderControls.vue?vue&type=style&index=0&id=e35ab188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35ab188",
  null
  
)

export default component.exports